import { ViewModel,View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { IUnit } from "../iUnit";
import  { UnitEditorView } from "./unitEditor-view"

export class UnitEditorViewModel extends ViewModel implements IUnit,IPopup{
    constructor(parentViewModel: ViewModel,updater : IServerUpdater) {
        super(parentViewModel);
        this._updater = updater;
    }
    GetDefaultView(): View <ViewModel> {
        return new UnitEditorView();
    }
    public getTypeId(): string {
        return "VM-3FC47401-C134-4CDF-B7C0-5801E7B269EC"
    }


    cloneTo(unit: IUnit) {
        unit.id = this.id;
        unit.name = this.name;
        unit.symbol = this.symbol;
    }

    closePopup(result: any) {
    }

    private _updater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set symbol(v: string) { this._symbol = v; } public get symbol(): string { return this._symbol;} private _symbol: string;
    

    
    back(){
        this.closePopup(null);
    }

    async save(){
        let verificationResult = this.verify();
        if(verificationResult.length>0){
            this.messageBoxConfirmWarning(verificationResult.join('\n'),'خطا در ثبت واحد');
            return;
        }else{
            try {
                this.isLoading = true;
                let result = await this._updater.execute(this);
                await this.messageBoxConfirmSuccess('واحد با موفقیت ثبت شد.','ثبت موفق');
                this.closePopup(this);
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning('خطا در ثبت واحد','خطا در عملیات');
            } finally {
                this.isLoading = false;
            }
        }
    }
    verify():string[]{
        let result :string[] = [];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام واحد مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.symbol)){
            result.push('نماد واحد مشخص نشده است.')
        }
        return result;
    }
}


export interface IServerUpdater{
    execute(unit:IUnit):Promise<any>;
}

export class UnitInserter implements IServerUpdater{
    async execute(unit: IUnit): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/UnitManipulationServices/CreateUnit',{
                Name:unit.name,
                Symbol : unit.symbol
            });
            if(result.IsSuccessful==false){
                throw "Error Saving Unit";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}

export class UnitUpdater implements IServerUpdater{
    async execute(unit: IUnit): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/UnitManipulationServices/UpdateUnit',{
                Id:unit.id,
                Name:unit.name,
                Symbol:unit.symbol
            });
            if(result.IsSuccessful==false){
                throw "Error Saving Unit";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}

